const radioStyles = theme => ({
  size: {
    width: 20,
    height: 20
  },
  sizeIcon: {
    fontSize: 16
  },
  checked: {},
  colorPrimary: {
    color: theme.palette.grey[400],
    '&$checked + $label': {
      color: theme.palette.primary.main
    }
  },
  colorSecondary: {
    '&$checked + $label': {
      color: theme.palette.secondary.main
    }
  },
  label: {
    color: theme.palette.grey['500']
  }
});

export default radioStyles;
